<sm-context-menu
  [items]="items"
  [triggerAriaLabel]="triggerAriaLabel"
  [triggerVariant]="triggerVariant"
  menuWidth="content"
  (itemSelect)="select($event)">
  <span smContextMenuTrigger><ng-content></ng-content></span>
</sm-context-menu>
